import { of } from 'rxjs';

export class SurveyServiceStub {
  getLatest() {
    return of(null);
  }
}
